// 기본 검색 객체
const defaultSearchParams = {
  searchType: "", // 검색 조건
  searchText: "", // 검색어
  currentPage: 1, // 현재 페이지
  recordSize: 10, // 한 페이지에 표시할 데이터 개수
  pageSize: 10, // 하단에 표시할 페이지 번호 개수
  startDt: "", // 시작일
  endDt: "",  // 종료일
  id: "", // 게시판 ID

  // 상세 분류
  cateId: "", // key
  cateValue: "", // value

  mbrId: "", // 목록 조회자 Id
  isAdmin: "", // 멤버 권한 관리자 여부 (권한 확인 용도)
};

export { defaultSearchParams };